import React from 'react';
import { FormattedMessage } from 'react-intl';

const Alert = props => {

    const { header, message, variation } = props;

    return (
        <div className={`usa-alert gi-alert gi-alert__left-accent gi-alert__${variation}`}>
            <div className="gi-alert__body">
                <h3 className="gi-alert__title">
                    <FormattedMessage
                        id={ header }
                    />
                </h3>
                <div className="gi-alert__text">
                    <FormattedMessage 
                        id={ message }
                        values={{
                            br: <br/>,
                            strong: chunks => <strong>{chunks}</strong>
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default Alert;
